module.exports = __webpack_public_path__ + "static/media/logo-trimble-landscape-1.977385ac.svg";